import React, {useEffect, useState} from "react";
import HelperService from "../../services/helper-service";
import helperService from "../../services/helper-service";
import {AttachmentTypes} from "../../utils/constants";
import Section from "../section";
import {Button, Modal} from "react-bootstrap";
import ArticleDetailContent from "./article-detail-content";

export default function Article({ article, direction='vertical', className, ...props}) {
  const [loading, setLoading] = useState(null);
  const [cover, setCover] = useState(null);
  const [show, setShow] = useState(false);

  useEffect(()=>{
    if (article){
      let ci = HelperService.getObjByKey(article.attachments, 'attachment_type_id', AttachmentTypes.cover.val);
      setCover(ci ? ci : null);

    } else {
      setCover(null);
    }
  }, [article]);

  const closeModal = () => setShow(false);

  return (
    <>
      {article && <>

        {direction==='horizontal' && <div className="row g-0 align-items-center" style={{minHeight: '205px'}}>
          <div className="col-md-3 rounded-start" style={{maxHeight: '195px', overflow: 'hidden'}}>
            {cover && <img src={cover?.url} className="img-fluid img-fit" alt="" />}
          </div>
          <div className="col-md-9">
            <div className="card-body position-relative">
              <h5 className="card-title">{article.title}</h5>
              <p className="card-text building-portfolio-text" style={{maxHeight: '110px'}} dangerouslySetInnerHTML={{__html: article.short_text? article.short_text : article.article}}></p>
              <div className={'row'}>
                <div className={'col-sm-12 col-md-6'}>
                  <p className="card-text"><small className="text-muted">{helperService.formatDateTime(article.created_at)}</small></p>
                </div>
                <div className={'col-sm-12 col-md-6'}>
                  <div className={"text-end"}>
                    <a onClick={(event)=>{event.preventDefault(); setShow(true)}} href="#" className="stretched-link btn btn-sm btn-soft-secondary rounded-pill">Viac <span className="mdi mdi-chevron-right"></span></a>
                    {/*<Link to={AppRoutes.articles.path+'/'+article.id} className="stretched-link link-secondary">Viac <span className="mdi mdi-chevron-right"></span></Link>*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>}


        {direction==='vertical' && <Section animation={HelperService.getRandomAnimation()}><div className="col-12 mb-3">
          <div className="card p-relative mb-0">
            <div className='row'>
              <div className='col-sm-12'>
                {cover && <img src={cover?.url} className="w-100 clickable rounded-top" alt="" />}
                <div className="card-body">
                  <h4 className="mb-0">{article.title}</h4>
                  <span className={`badge bg-success`}>{helperService.formatDateTime(article.created_at)}</span>
                  <p className="card-text my-2 building-portfolio-text" style={{maxHeight: '110px'}} dangerouslySetInnerHTML={{__html: article.short_text? article.short_text : article.article}}></p>
                  <div className={"text-end"}>
                    <a onClick={(event)=>{event.preventDefault(); setShow(true)}} href="#" className="stretched-link btn btn-sm btn-soft-secondary rounded-pill">Viac <span className="mdi mdi-chevron-right"></span></a>
                    {/*<Link to={AppRoutes.articles.path+'/'+article.id} className="stretched-link link-secondary">Viac <span className="mdi mdi-chevron-right"></span></Link>*/}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div></Section>}

        <Modal size={'xl'} show={!!show} onHide={closeModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>{article.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Section animation={HelperService.getRandomAnimation()}>

              {/*{loading && <Loading className="m-2" />}*/}
              {!!show && <ArticleDetailContent article={article} />}

            </Section>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-secondary" onClick={closeModal}>Zatvoriť</Button>
          </Modal.Footer>
        </Modal>
      </>}
    </>
  );
}
